import { Box, Flex, Icon, theme } from '@energiebespaarders/symbols';
import { Center, Heading } from '@energiebespaarders/symbols/helpers';
import { useIsMobile } from '@energiebespaarders/symbols/hooks';
import styled from 'styled-components';
import BlockContainer from './DatoCms/BlockContainer';
import type { containers } from '@energiebespaarders/symbols/styles/theme';
import type { ReactNode } from 'react';

export interface IStep {
  id: string;
  title: string;
  text: string;
  icon: ReactNode;
  hideDottedLine?: boolean;
}

export interface StepperProps {
  title: string;
  steps: IStep[];
  backgroundColor?: string;
  containerSize: keyof typeof containers;
}

const DottedLine = styled(Box)`
  width: 100%;
  border: 0px;
  border-bottom: 1px black;
  border-style: dashed solid;
  opacity: 0.5;
`;

const StyledIcon = styled(Icon)`
  span {
    line-height: 0px;
  }

  transform: rotate(100deg);
`;

const StepContainer = styled(Box)`
  min-height: 150px;
`;

const Stepper: React.FC<StepperProps> = ({
  title,
  steps,
  backgroundColor = theme.colors.greenSlate,
  containerSize,
}) => {
  const isMobile = useIsMobile();

  return (
    <BlockContainer
      size={containerSize}
      backgroundColor={backgroundColor}
      style={{ borderRadius: 6 }}
      py={isMobile ? 4 : 10}
      pt={10}
    >
      <Box style={{ position: 'relative' }} width={1}>
        <Center block>
          <Heading heading="h2" fontSize={3}>
            {title}
          </Heading>
        </Center>
        <Flex flexWrap="wrap">
          {steps?.map(c => (
            <StepContainer width={[1, 1, 1 / 3]} key={c.id} px={4}>
              <Flex width={1} alignItems="center" mb={2}>
                <StyledIcon icon={c.icon} mr={3} />
                {!c.hideDottedLine && <DottedLine />}
              </Flex>

              <Heading heading="h3" fontSize={4}>
                {c.title}
              </Heading>
              <p>{c.text}</p>
            </StepContainer>
          ))}
        </Flex>
      </Box>
    </BlockContainer>
  );
};

export default Stepper;
